import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import {ellipsis} from 'ag-common/tools/string'
import StyledText from '#components/a/StyledText'
import CommentActiveIcon from '#components/svg/icons/CommentActiveIcon'
import {routeKeys} from '#config/routeKeys'

export default class AufgabeKommentierenBenachrichtigung extends React.Component {
  onClickNotification = () => {
    const {onNotificationClick} = this.props
    onNotificationClick(routeKeys.praxisaufgabenOverview)
  }

  render() {
    const {abteilungName, text} = this.props
    const textString = i18n.t('notification_text_aufgabe_kommentieren', [abteilungName, ellipsis(text, 20)])
    return (
      <div
        role="button"
        tabIndex={0}
        className="notification"
        onClick={this.onClickNotification}
        onKeyPress={this.onClickNotification}
      >
        <div className="notification__icon">
          <CommentActiveIcon />
        </div>
        <StyledText text={textString} modifier="notification" />
      </div>
    )
  }
}

AufgabeKommentierenBenachrichtigung.propTypes = {
  abteilungName: PropTypes.string,
  onNotificationClick: PropTypes.func.isRequired,
  text: PropTypes.string,
}
